import React from 'react';
import PropTypes from 'prop-types';
import { QRCodeSVG } from 'qrcode.react';

// Карточка точки (.lg-point): QR-код, номер, название и код точки.
// React.memo + стабильный onOpen: стейт родителя (модалки/табы) не перерисовывает сетку QR.
const PointCard = React.memo(function PointCard({ point, index, qrBaseUrl, onOpen }) {
    const qrValue = qrBaseUrl ? `${qrBaseUrl}${point.code}` : point.code;
    const open = () => onOpen(point.id);
    return (
        <div className="lg-point" role="button" tabIndex={0} onClick={open} onKeyDown={(e) => { if (e.key === 'Enter') open(); }}>
            <div className="lg-qr">
                {point.code && <QRCodeSVG value={qrValue} size={52} level="M" />}
                <span className="lg-pnum">{index + 1}</span>
            </div>
            <div className="lg-pinfo">
                <div className="lg-pname">{point.name || 'Без названия'}</div>
                <div className="lg-pcode">Код: {point.code}</div>
            </div>
        </div>
    );
});

PointCard.propTypes = {
    point: PropTypes.shape({ id: PropTypes.number, name: PropTypes.string, code: PropTypes.string }).isRequired,
    index: PropTypes.number.isRequired,
    qrBaseUrl: PropTypes.string,
    onOpen: PropTypes.func.isRequired
};

PointCard.defaultProps = { qrBaseUrl: null };

export default PointCard;
